import React from 'react';
import { useNavigate } from 'react-router-dom';

function PrivacyPage() {
  const navigate = useNavigate();

  const sectionStyle = { marginBottom: '28px' };
  const h2Style = { color: 'var(--primary)', fontSize: '20px', marginBottom: '12px', fontWeight: '700' };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--light-bg)' }}>
      <div className="header">
        <div className="header-content">
          <h1 className="logo" onClick={() => navigate('/')} style={{cursor: 'pointer'}}>وِداد</h1>
        </div>
      </div>

      <div className="container" style={{ paddingTop: '30px', paddingBottom: '60px', maxWidth: '800px' }}>
        <div className="card fade-in" style={{ padding: '36px 28px', borderRadius: '20px' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '32px' }}>
            <h1 style={{ fontSize: '28px', color: 'var(--text-dark)', marginBottom: '8px' }}>
              سياسة الخصوصية
            </h1>
            <p style={{ color: 'var(--text-light)', fontSize: '14px' }}>
              آخر تحديث: مايو 2026
            </p>
          </div>

          <div style={{ lineHeight: '2', color: 'var(--text-dark)', fontSize: '15px' }}>
            
            {/* English Summary - For Payment Gateway Review */}
            <section style={{ 
              ...sectionStyle,
              background: 'rgba(0, 137, 123, 0.06)',
              border: '1px solid rgba(0, 137, 123, 0.2)',
              borderRadius: '12px',
              padding: '20px',
              direction: 'ltr',
              textAlign: 'left'
            }}>
              <h2 style={{ ...h2Style, fontSize: '17px' }}>Privacy Summary (English)</h2>
              <p style={{ fontSize: '14px', lineHeight: '1.8' }}>
                <strong>Widad</strong> collects only the data necessary to operate a membership-based matrimonial
                matching service: identification (name, email, date of birth), demographic and lifestyle attributes
                (used for compatibility matching), and member-uploaded photos (subject to manual moderation).
                We comply with the <strong>Saudi Personal Data Protection Law (PDPL)</strong> and never sell user
                data to third parties. Payment processing is handled by an external <strong>PCI-DSS compliant
                payment provider</strong>; we do not store credit card or banking details on our servers. Users may
                request data export or deletion at any time by emailing <strong>help@wedad.online</strong>.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>بسم الله الرحمن الرحيم</h2>
              <p>
                نحن في منصة <strong>وِداد</strong> نُقدّر خصوصيتك ونلتزم بحماية بياناتك الشخصية وفقاً لنظام حماية البيانات الشخصية في المملكة العربية السعودية. توضح هذه السياسة كيفية جمع واستخدام وحماية معلوماتك.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>1. البيانات التي نجمعها</h2>
              
              <h3 style={{ fontSize: '16px', marginBottom: '8px', color: 'var(--text-dark)', fontWeight: '600' }}>بيانات التسجيل:</h3>
              <ul style={{ paddingRight: '24px', marginBottom: '16px' }}>
                <li>الاسم الكامل والبريد الإلكتروني</li>
                <li>تاريخ الميلاد والجنس</li>
                <li>الجنسية والمدينة</li>
              </ul>
              
              <h3 style={{ fontSize: '16px', marginBottom: '8px', color: 'var(--text-dark)', fontWeight: '600' }}>بيانات الملف الشخصي:</h3>
              <ul style={{ paddingRight: '24px', marginBottom: '16px' }}>
                <li>المعلومات الشخصية (الحالة الاجتماعية، القبيلة، المذهب)</li>
                <li>المعلومات المهنية والتعليمية</li>
                <li>المظهر الخارجي (الطول، الوزن، لون البشرة)</li>
                <li>الصور الشخصية</li>
              </ul>
              
              <h3 style={{ fontSize: '16px', marginBottom: '8px', color: 'var(--text-dark)', fontWeight: '600' }}>بيانات الاستخدام:</h3>
              <ul style={{ paddingRight: '24px' }}>
                <li>سجل الرسائل والمحادثات</li>
                <li>طلبات التواصل المُرسلة والمُستلمة</li>
                <li>سجل البحث والتفضيلات</li>
                <li>بيانات الجهاز والمتصفح (لأغراض تقنية)</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>2. كيف نستخدم بياناتك</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}><strong>تقديم الخدمة:</strong> عرض ملفك للمستخدمين المناسبين وتسهيل التواصل</li>
                <li style={{ marginBottom: '6px' }}><strong>تحسين التوافق:</strong> اقتراح ملفات متوافقة باستخدام الذكاء الاصطناعي</li>
                <li style={{ marginBottom: '6px' }}><strong>الأمان:</strong> حماية المستخدمين من الاحتيال والسلوكيات المخالفة</li>
                <li style={{ marginBottom: '6px' }}><strong>التواصل:</strong> إرسال إشعارات مهمة متعلقة بحسابك</li>
                <li style={{ marginBottom: '6px' }}><strong>تحسين الخدمة:</strong> تطوير وتحسين أداء المنصة بناءً على أنماط الاستخدام</li>
                <li style={{ marginBottom: '6px' }}><strong>الالتزام القانوني:</strong> الامتثال للمتطلبات النظامية في المملكة العربية السعودية</li>
              </ul>
            </section>

            <section style={{ 
              ...sectionStyle, 
              background: 'rgba(0, 137, 123, 0.08)', 
              padding: '20px', borderRadius: '12px',
              border: '1px solid rgba(0, 137, 123, 0.15)'
            }}>
              <h2 style={h2Style}>3. كيف نحمي بياناتك</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}><strong>التشفير:</strong> جميع البيانات مشفرة أثناء النقل (SSL/TLS) والتخزين</li>
                <li style={{ marginBottom: '6px' }}><strong>الوصول المحدود:</strong> فقط الموظفون المخولون يمكنهم الوصول للبيانات</li>
                <li style={{ marginBottom: '6px' }}><strong>المراقبة المستمرة:</strong> نظام مراقبة للكشف عن أي محاولات اختراق</li>
                <li style={{ marginBottom: '6px' }}><strong>النسخ الاحتياطي:</strong> نسخ احتياطية منتظمة ومشفرة</li>
                <li style={{ marginBottom: '6px' }}><strong>مراجعة الصور:</strong> جميع الصور تخضع للمراجعة قبل النشر</li>
                <li style={{ marginBottom: '6px' }}><strong>كلمات المرور:</strong> تُخزن بشكل مُشفر (hashed) ولا يمكن الاطلاع عليها</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>4. مشاركة البيانات</h2>
              <p style={{ marginBottom: '12px', fontWeight: '600' }}>
                نحن لا نبيع بياناتك الشخصية لأي طرف ثالث إطلاقاً.
              </p>
              <p style={{ marginBottom: '12px' }}>قد نشارك بياناتك في الحالات التالية فقط:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}><strong>المستخدمون الآخرون:</strong> المعلومات التي تختار عرضها في ملفك الشخصي فقط</li>
                <li style={{ marginBottom: '6px' }}><strong>مقدمو خدمات الدفع:</strong> البيانات الضرورية لإتمام المعاملات المالية فقط</li>
                <li style={{ marginBottom: '6px' }}><strong>مقدمو الخدمات التقنية:</strong> خدمات البريد الإلكتروني والإشعارات (بالحد الأدنى من البيانات)</li>
                <li style={{ marginBottom: '6px' }}><strong>المتطلبات القانونية:</strong> عند وجود أمر قضائي أو طلب رسمي من الجهات المختصة في المملكة</li>
              </ul>
            </section>

            <section style={{ 
              ...sectionStyle, 
              background: 'rgba(211, 47, 47, 0.08)', 
              padding: '20px', borderRadius: '12px',
              border: '1px solid rgba(211, 47, 47, 0.2)'
            }}>
              <h2 style={{ ...h2Style, color: 'var(--error)' }}>5. خصوصية المحادثات</h2>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>المحادثات محفوظة بشكل آمن ومشفر</li>
                <li style={{ marginBottom: '6px' }}>لا يطلع عليها أحد إلا في حال وجود بلاغ أو شكوى رسمية</li>
                <li style={{ marginBottom: '6px' }}>يحق للإدارة مراجعة المحادثات للتحقق من الالتزام بالشروط</li>
                <li style={{ marginBottom: '6px' }}><strong>تحذير:</strong> أي محاولة لتبادل أرقام أو حسابات تواصل يتم رصدها</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>6. حقوقك</h2>
              <p style={{ marginBottom: '12px' }}>وفقاً لنظام حماية البيانات الشخصية، يحق لك:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}><strong>الوصول:</strong> طلب نسخة من بياناتك الشخصية المخزنة لدينا</li>
                <li style={{ marginBottom: '6px' }}><strong>التصحيح:</strong> تعديل بياناتك في أي وقت من إعدادات حسابك</li>
                <li style={{ marginBottom: '6px' }}><strong>الحذف:</strong> طلب حذف حسابك وجميع بياناتك نهائياً</li>
                <li style={{ marginBottom: '6px' }}><strong>الاعتراض:</strong> الاعتراض على معالجة بياناتك لأغراض معينة</li>
                <li style={{ marginBottom: '6px' }}><strong>التقييد:</strong> طلب تقييد معالجة بياناتك مؤقتاً</li>
                <li style={{ marginBottom: '6px' }}><strong>نقل البيانات:</strong> طلب نقل بياناتك بصيغة إلكترونية قابلة للقراءة</li>
                <li style={{ marginBottom: '6px' }}><strong>سحب الموافقة:</strong> سحب موافقتك على معالجة البيانات في أي وقت</li>
              </ul>
              <p style={{ marginTop: '12px', color: 'var(--text-light)', fontSize: '14px' }}>
                لممارسة أي من حقوقك، تواصل معنا عبر <strong>help@wedad.online</strong> وسنستجيب خلال 30 يوماً.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>7. ملفات تعريف الارتباط (Cookies)</h2>
              <p>نستخدم ملفات تعريف الارتباط لـ:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>الحفاظ على تسجيل دخولك</li>
                <li style={{ marginBottom: '6px' }}>تذكر تفضيلاتك (مثل الوضع الليلي)</li>
                <li style={{ marginBottom: '6px' }}>تحسين أداء الموقع</li>
              </ul>
              <p>يمكنك تعطيل ملفات تعريف الارتباط من إعدادات متصفحك، لكن ذلك قد يؤثر على بعض الوظائف.</p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>8. حذف الحساب والاحتفاظ بالبيانات</h2>
              <p>عند طلب حذف حسابك:</p>
              <ul style={{ paddingRight: '24px' }}>
                <li style={{ marginBottom: '6px' }}>يتم إخفاء ملفك الشخصي فوراً من العرض</li>
                <li style={{ marginBottom: '6px' }}>يتم حذف صورك ورسائلك نهائياً خلال 30 يوماً</li>
                <li style={{ marginBottom: '6px' }}>قد نحتفظ ببيانات محدودة لمدة 90 يوماً لأغراض أمنية وقانونية</li>
                <li style={{ marginBottom: '6px' }}>بعد انقضاء المدة، تُحذف جميع البيانات نهائياً وبشكل غير قابل للاسترجاع</li>
              </ul>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>9. حماية الأطفال</h2>
              <p>
                منصة وِداد مخصصة للبالغين فقط (18 سنة فأكثر). لا نجمع بيانات من أي شخص دون سن 18 عاماً عن علم. إذا اكتشفنا حساباً لقاصر، سيتم حذفه فوراً.
              </p>
            </section>

            <section style={sectionStyle}>
              <h2 style={h2Style}>10. تعديل السياسة</h2>
              <p>
                قد نقوم بتحديث سياسة الخصوصية من وقت لآخر. سنقوم بإشعارك بأي تغييرات جوهرية عبر البريد الإلكتروني أو من خلال إشعار على المنصة. ننصحك بمراجعة هذه الصفحة دورياً.
              </p>
            </section>

            <section style={{ 
              background: 'rgba(0, 137, 123, 0.08)', 
              padding: '20px', borderRadius: '12px', textAlign: 'center'
            }}>
              <h2 style={h2Style}>تواصل معنا</h2>
              <p>
                لأي استفسارات تتعلق بالخصوصية أو لممارسة حقوقك:<br/>
                <strong style={{ color: 'var(--primary)' }}>help@wedad.online</strong>
              </p>
              <button 
                className="btn btn-primary"
                onClick={() => navigate('/contact')}
                style={{ marginTop: '12px', padding: '10px 24px', fontSize: '14px' }}
              >
                صفحة اتصل بنا
              </button>
            </section>
          </div>

          <button 
            className="btn btn-primary"
            onClick={() => navigate(-1)}
            style={{ marginTop: '24px', width: '100%' }}
          >
            رجوع
          </button>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPage;
